<template>
    <div class="user-list">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h2 class="mb-0">{{ $t('room.list_title') }}</h2>
            <router-link :to="{ name: 'CreateRoom' }" class="btn btn-primary">
                <b-icon icon="plus" class="icon-style"></b-icon>
                {{ $t('room.add_room_title') }}
            </router-link>
        </div>

        <CrudTable :columns="fields" :data-sources="rooms" :loader="loader"
            :list-url="`/rooms?room_type_id=${$route.params.id}`" ref="room-table">
            <template v-slot:cell(dimensions)="data">
                {{ data.item.width }} × {{ data.item.length }}
            </template>
            <template v-slot:cell(accessibility_support)="data">
                {{ data.item.accessibility_support ? $t('common.yes') : $t('common.no') }}
            </template>
            <template v-slot:cell(actions)="data">
                <div :class="['d-flex', 'gap-2']">
                    <router-link
                        :to="{ name: 'EditRoomTypeRoom', params: { id: $route.params.id, room_id: data.item.id } }"
                        class="btn btn-outline-primary btn-sm" :title="$t('room.edit_details')">
                        <i class="fas fa-edit"></i>
                    </router-link>

                    <b-button variant="outline-danger" size="sm" @click="confirmDelete(data.item)">
                        <i class="fas fa-trash"></i>
                    </b-button>
                </div>
            </template>

            <template v-slot:cell(status)="data">
                <span class="badge px-3 py-1 rounded-pill" :class="statusBadgeClass(data.item.status)">
                    {{ $t('room.status_' + data.item.status) }}
                </span>
            </template>


        </CrudTable>
        <ConfirmDeleteModal v-if="selectedItem" 
            :show.sync="showDeleteModal"
            :item-id="selectedItem.id"
            delete-url="/rooms" :message="$t(`room.confirm_delete_message`)"
            success-message="$t('room.deleted_successfully')" error-message="$t('common.something_went_wrong')"
            @deleted="handleItemDeleted" />
    </div>
</template>

<script>
import CrudTable from "@/components/CrudTable.vue";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { mapGetters } from 'vuex';
export default {
    name: 'RoomList',
    components: {
        CrudTable,
        ConfirmDeleteModal
    },

    data() {
        return {
            rooms: [],
            currentPage: 1,
            perPage: 10,
            sortBy: 'created_at',
            sortDesc: true,
            filters: {
                search: '',
                room_number: null,
                floor: null,
                max_guests: null,
                status: null
            },
            showDeleteModal: false,
            selectedItem: null,
            fields: [
                { key: 'room_number', label: this.$t('room.room_number_heading'), sortable: true, sortDirection: 'asc' },
                { key: 'room_type.name', label: this.$t('room.room_type_heading'), sortable: true, sortDirection: 'asc' },
                { key: 'room_type.bed_type', label: this.$t('room.bed_size_heading'), sortable: true, sortDirection: 'asc' },
                { key: 'size_sqft', label: this.$t('room.size_sqft_heading'), sortable: false },
                { key: 'floor', label: this.$t('room.floor_heading'), sortable: true, sortDirection: 'asc' },
                { key: 'view', label: this.$t('room.view_heading'), sortable: false },
                { key: 'accessibility_support', label: this.$t('room.accessibility_support_heading'), sortable: false },
                { key: 'status', label: this.$t('room.status_heading'), sortable: true, sortDirection: 'asc' },
                { key: 'actions', label: this.$t('room.actions'), sortable: false }
            ],
            statusOptions: [
                { value: 'available', text: this.$t('user.status_available') },
                { value: 'under_maintenance', text: this.$t('user.under_maintenance_status') },
            ],

        }
    },

    methods: {
        handleSearch(search) {
            this.filters.search = search;
            this.currentPage = 1;
        },
        handleFilter(filter) {
            this.filters = { ...this.filters, ...filter };
            this.currentPage = 1;
        },
        confirmDelete(item) {
            this.selectedItem = item;
            this.showDeleteModal = true;
        },
        handleItemDeleted() {
            this.$refs['room-table'].refreshTableData();
            this.$bvToast.toast(this.$t('room.deleted_successfully'), {
                title: this.$t('common.success'),
                variant: 'success',
                solid: true
            });
            this.showDeleteModal = false;
            this.selectedItem = null;
        },
        statusBadgeClass(status) {
            switch (status) {
                case 'available': return 'bg-success text-white';
                case 'reserved': return 'bg-primary text-white';
                case 'occupied': return 'bg-dark text-white';
                case 'cleaning': return 'bg-warning text-dark';
                case 'maintenance': return 'bg-secondary text-white';
                case 'unavailable': return 'bg-danger text-white';
                default: return 'bg-light text-dark';
            }
        },
    },
    computed: {
        ...mapGetters(['loader'])
    }
}
</script>

<style scoped>
.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #007bff;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
}

.badge-info {
    color: #212529 !important;
    /* Bootstrap's text-dark */
}
</style>